import { Visibility } from '@fullstory/proto/fs/gcloud/dstore/protoauditstore';
import { GetAllDefinedEventsResponse } from '@fullstory/proto/fs/services/dx-objects';
import { int64, timestamp } from '@fullstory/proto/google/protobuf';

export const DEFINED_EVENTS_RESPONSE: GetAllDefinedEventsResponse = {
  definedEvents: [],
  activeLimit: 1000,
};

export const REVENUE_DEFINED_EVENTS_RESPONSE: GetAllDefinedEventsResponse = {
  definedEvents: [
    {
      definedEvent: {
        definedEvent: {
          id: 'definedEvent',
          name: 'Revenue Event',
          description: 'Event used to calculate funnel revenue insights',
          events: [
            {
              primary: {
                custom: {
                  named: { name: 'Checkout' },
                },
              },
              deps: [],
            },
          ],
        },
        definedEventMetadata: { fsManaged: true },
        metadata: {
          lastUpdated: '2023-05-01T14:55:31.807922Z' as timestamp,
          lastUpdatedBy: 'jefftorson@fullstory.com',
          created: '2023-05-01T14:55:31.807922Z' as timestamp,
          createdBy: 'test@fullstory.com',
          archived: false,
          visibility: Visibility.UNSET,
          version: '1681397731807' as int64,
          sequentialVersion: '1' as int64,
        },
        createIdempotenceKey: '',
      },
    },
  ],
  activeLimit: 1000,
};

export const MULTIPLE_DEFINED_EVENTS_RESPONSE: GetAllDefinedEventsResponse = {
  definedEvents: [
    {
      definedEvent: {
        definedEvent: {
          id: 'definedEvent',
          name: 'Revenue Event',
          description: 'Event used to calculate funnel revenue insights',
          events: [
            {
              primary: {
                custom: {
                  named: { name: 'Checkout' },
                },
              },
              deps: [],
            },
          ],
        },
        definedEventMetadata: { fsManaged: true },
        metadata: {
          lastUpdated: '2023-05-01T14:55:31.807922Z' as timestamp,
          lastUpdatedBy: 'jefftorson@fullstory.com',
          created: '2023-05-01T14:55:31.807922Z' as timestamp,
          createdBy: 'test@fullstory.com',
          archived: false,
          visibility: Visibility.UNSET,
          version: '1681397731807' as int64,
          sequentialVersion: '1' as int64,
        },
        createIdempotenceKey: '',
      },
    },
    {
      definedEvent: {
        definedEvent: {
          id: 'archivedEvent',
          name: 'Archived Events',
          description: 'Event used to test archive logic',
          events: [
            {
              primary: {
                custom: {
                  named: { name: 'Checkout' },
                },
              },
              deps: [],
            },
          ],
        },
        definedEventMetadata: { fsManaged: true },
        metadata: {
          lastUpdated: '2023-05-01T14:55:31.807922Z' as timestamp,
          lastUpdatedBy: 'jefftorson@fullstory.com',
          created: '2023-05-01T14:55:31.807922Z' as timestamp,
          createdBy: 'test@fullstory.com',
          archived: true,
          visibility: Visibility.UNSET,
          version: '1681397731807' as int64,
          sequentialVersion: '1' as int64,
        },
        createIdempotenceKey: '',
      },
    },
  ],
  activeLimit: 1000,
};
